import { Navigate, Outlet } from 'react-router-dom'
import { Loading } from '@/components/loading'
import { useCanUseBenefitsResolved } from '@/hooks/useCanUseBenefits'
import { ROUTE_DASHBOARD } from '@/constants/Routes'

/**
 * The gate for the benefits ROUTES, as opposed to an entry point that can simply not render.
 *
 * A layout route wrapping the whole group, so a route is gated by being inside it rather than by
 * each page remembering to check. Every one of these URLs is shareable — a claim link in an email,
 * a bookmarked inbox — so the routes stay registered whether or not the feature is on for this
 * user; removing them would resolve a real link to the 404 page instead of to something honest.
 *
 * Three states, and the middle one is why this exists rather than a bare boolean:
 * - not settled — hold. Somebody who followed a claim link must not be redirected away during the
 *   moment before their flags arrive.
 * - settled and off — go to the dashboard. Rendering "not available" would explain a feature they
 *   have no way to turn on, and `replace` keeps the dead URL out of their history so Back does not
 *   walk them into the same redirect again.
 * - settled and on — the route.
 */
export const BenefitsRouteGate = () => {
  const { enabled, isResolved } = useCanUseBenefitsResolved()

  if (!isResolved) return <Loading />
  if (!enabled) return <Navigate to={ROUTE_DASHBOARD} replace />

  return <Outlet />
}

export default BenefitsRouteGate
